import { render, staticRenderFns } from "./DocumentLoyaltyFaq.vue?vue&type=template&id=6bb0139e&"
import script from "./DocumentLoyaltyFaq.vue?vue&type=script&lang=js&"
export * from "./DocumentLoyaltyFaq.vue?vue&type=script&lang=js&"
import style0 from "./DocumentLoyaltyFaq.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports